import React, { useState, useEffect } from "react";
import { Modal, ModalBody, Form, Row, Col } from "reactstrap";
import StyledButton from "../../components/Common/StyledButton";
import { createBudget, createEditTaxIdentity, deleteBudget, deleteTaxIdentity, updateBudget } from "../../api";
import { toast } from "react-toastify";

const BudgetModal = ({ clientId, branchId, openModal, setOpenModal, editId = null, values, updateBudgetList }) => {
  const [fieldType, setFieldType] = useState("");
  const [fieldValue, setFieldValue] = useState("");
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const notify = (type, message) => {
    if (type === 'Error') {
      toast.error(message, {
        position: 'top-center',
        theme: 'colored',
      });
    } else {
      toast.success(message, {
        position: 'top-center',
        theme: 'colored',
      });
    }
  };

  useEffect(() => {
    if (editId) {
        setFieldType(values.fieldType);
        setFieldValue(values.fieldValue);
    } else {
      setFieldType("");
      setFieldValue("");
    }
  }, [openModal, editId, values]);

  const createOrEditBudgetModal = async () => {
    setIsButtonLoading(true);

    let response;
    if (editId) {
      response = await updateBudget({
        branchId,
        _id: editId,
        period: fieldType,
        amount: fieldValue,
      });
    } else {
      response = await createBudget({
        clientId,
        branchId,
        period: fieldType,
        amount: fieldValue,
      });
    }

    if (response.success) {
      const budget = response.payload.budget;
      notify("success", response.message);
      updateBudgetList(branchId, budget);
      setIsButtonLoading(false);
      setOpenModal(false);
    } else {
       notify("Error", response.message);
       setIsButtonLoading(false);
       setOpenModal(false);
    }
  }

  const checkFieldChanged = () => {
    if (editId) {
        return fieldType === values.fieldType && fieldValue === values.fieldValue;
    }
    return false;
  };

  const onDeleteBudget = async () => {
    const response = await deleteBudget(editId);
    if (response.success) {
      notify("success", response.message);
      updateBudgetList(branchId, {_id: editId }, true);
      setOpenModal(false);
    } else {
       notify("Error", response.message);
       setOpenModal(false);
    }
  };

  return (
    <Modal
      size="md"
      centered
      isOpen={openModal}
      toggle={() => setOpenModal(false)}
    >
        <div className="modal-header">
          <h4>{editId ? "Edit Budget Limit" : "Add Budget Limit"}</h4>
          <StyledButton outline color="danger" onClick={() => setOpenModal(false)}>
            Close
          </StyledButton>
        </div>

        <ModalBody>
          <Row>
            <Col className="mt-2">
              <label className="item-name">Select Type</label>
              <select
                className="form-select"
                value={fieldType}
                onChange={(e) => {
                  const val = e.target.value;
                  setFieldType(val);
                  if (!val) {
                    setFieldValue('');
                  }
                }}
              >
                <option value="">Select Type</option>
                <option value="once">Every Budget</option>
                <option value="monthly">Monthly</option>
                <option value="quarterly">Quarterly</option>
              </select>
            </Col>
          </Row>

          <Row>
            <Col className="mt-3">
              <label className="item-name">Enter Amount(₹)</label>
              <input
                type="text"
                className="form-control"
                placeholder={'Enter Amount(₹)'}
                value={fieldValue}
                disabled={!fieldType}
                onChange={(e) => {
                  const val = e.target.value;
                    const amount = val.replace(/[^0-9]/g, '');
                    setFieldValue(amount);
                }}
              />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <StyledButton
                color={"primary"}
                className={"w-md mx-2"}
                onClick={createOrEditBudgetModal}
                isLoading={isButtonLoading}
                disabled={checkFieldChanged()}
              >
                {editId ? "Update" : "Save"}
              </StyledButton>
              {editId && (
                <StyledButton
                  color="danger"
                  className={"w-md mx-2"}
                  onClick={onDeleteBudget}
                  isLoading={isButtonLoading}
                >
                  Delete
                </StyledButton>
                )}
            </Col>
          </Row>
        </ModalBody>
    </Modal>
  );
};

export default BudgetModal;